export default "__VITE_ASSET__Uwwfaoa$__"